<template>
  <div class="userstate">
    <signModule :inputState="status>=1"></signModule>
  </div>
</template>

<script>
import signModule from "../../components/signModule.vue";
import { getRegistrationInfo } from "../API/user";
export default {
  name: "userstate",
  components: {
    signModule,
  },
  props: {},
  data() {
    return {
      status:0,
      hasRegistered: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getUserState();
  },
  mounted() {},
  methods: {
    async getUserState() {
      const { data: res } = await getRegistrationInfo();
      if (this.hasRegistered) {
        this.status = res.data.data?.status;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
